
window.__rowTargetHash = window.location.hash;

if (window.__rowTargetHash) {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
  window.scrollTo(0, 0);
}

document.querySelectorAll('.photo').forEach(el => {
  const delay = 5 + Math.random() * 15; // 5–20 seconds
  el.style.setProperty('--shine-delay', delay + 's');
});



// Auto scroll to row and highlight
(function () {
  const STORAGE_KEY = "lastTableRows";

  function getTable() {
    return document.querySelector("[data-row-memory][data-row-memory-group]");
  }

  function readStore() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function writeStore(data) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  }

  function clearStore() {
    sessionStorage.removeItem(STORAGE_KEY);
  }

  function keepOnlyGroup(groupName) {
    const data = readStore();
    const next = {};

    if (groupName && data[groupName]) {
      next[groupName] = data[groupName];
    }

    writeStore(next);
  }

  function saveRow(groupName, pageKey, rowId) {
    const data = readStore();

    if (!data[groupName]) {
      data[groupName] = {};
    }

    data[groupName][pageKey] = rowId;
    writeStore(data);
  }

  function getSavedRow(groupName, pageKey) {
    const data = readStore();
    return data[groupName] && data[groupName][pageKey]
      ? data[groupName][pageKey]
      : null;
  }

  function highlightRow(row) {
    row.classList.add("row-target-highlight");

    setTimeout(function () {
      row.classList.remove("row-target-highlight");
    }, 2600);
  }

  function scrollToRow(row) {
    row.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });
  }

  function restoreRow() {
  const table = getTable();

  if (!table) {
    clearStore();
    return;
  }

  const pageKey = table.dataset.rowMemory;
  const groupName = table.dataset.rowMemoryGroup;
  const hash = window.location.hash;

  let targetId = null;
  let row = null;

  if (hash) {
    const hashId = hash.replace("#", "");
    const hashElement = document.getElementById(hashId);

    // Only use hash if it is actually a row
    if (hashElement && hashElement.classList.contains("row")) {
      targetId = hashId;
      row = hashElement;
    }
  }

  if (!row) {
    targetId = getSavedRow(groupName, pageKey);
    if (!targetId) return;

    row = document.getElementById(targetId);
    if (!row || !row.classList.contains("row")) return;
  }

  setTimeout(function () {
    scrollToRow(row);
    highlightRow(row);
  }, 80);
}

  function init() {
    const table = getTable();

    if (!table) {
      clearStore();
      return;
    }

    const pageKey = table.dataset.rowMemory;
    const groupName = table.dataset.rowMemoryGroup;

    keepOnlyGroup(groupName);

    table.addEventListener("click", function (event) {
      const row = event.target.closest(".row[id]");
      if (!row) return;

      saveRow(groupName, pageKey, row.id);
    });
  }

  document.addEventListener("DOMContentLoaded", init);
  window.addEventListener("pageshow", restoreRow);
})();


//Quick navigation links with smooth scroll
document.addEventListener("click", function (event) {

  const link = event.target.closest(".js-section-link");
  if (!link) return;

  const href = link.getAttribute("href");
  if (!href || href.charAt(0) !== "#") return;

  const target = document.querySelector(href);
  if (!target) return;

  event.preventDefault();

  const OFFSET = 200;
  const y = target.getBoundingClientRect().top + window.scrollY - OFFSET;

  window.scrollTo({
    top: y,
    behavior: "smooth"
  });

  history.replaceState(null, "", href);

});